














import { Component, Vue, Prop } from 'vue-property-decorator';
@Component
export default class TableDataTag extends Vue {
  // 表示に使用するクラス
  @Prop({ default: '' })
  private classCSS?: string;
  // 表示・非表示をするフラグ
  @Prop({ default: true })
  private isShow?: boolean;
  // 表示・非表示をする文言
  @Prop() private str?: string;
}
